function getUserGeolocation() {
  return new Promise((resolve, reject) => {
    const coordinates = {
      latitude: null,
      longitude: null,
      error: false
    };
    const options = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 3000000
    };
    function success(pos) {
      coordinates.latitude = pos.coords.latitude.toString();
      coordinates.longitude = pos.coords.longitude.toString();
      localStorage.setItem("oa_user_location", JSON.stringify(coordinates));
      resolve(coordinates);
    }

    function fail(error) {
      if (error.code !== error.PERMISSION_DENIED) {
        coordinates.latitude = "";
        coordinates.longitude = "";
        coordinates.error = true;
        resolve(coordinates);
      }
    }
    navigator.geolocation.getCurrentPosition(success, fail, options);
  });
}

window.addEventListener("load", () => {
  window.getUserGeolocation = () => getUserGeolocation();
});
